import { render, staticRenderFns } from "./showImgList.vue?vue&type=template&id=33ae66fb&scoped=true&"
import script from "./showImgList.vue?vue&type=script&lang=js&"
export * from "./showImgList.vue?vue&type=script&lang=js&"
import style0 from "./showImgList.vue?vue&type=style&index=0&id=33ae66fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ae66fb",
  null
  
)

export default component.exports